import React from "react";
import {Reward} from "@jnext/ts-axios-eventformat";
import './style/T1.scss';
import { JHTML } from "../JHTML";
import { JSliderReward } from "../JSlider/components";
import {CMSSection} from "../models";
import {useTranslation} from "react-i18next";

export type JCarouselProps =  {
    title?: string;
    subTitle?: string;
    rewards?: Reward[];
    section?: CMSSection|undefined;
}

export const JRewardsCarousel: React.FC<JCarouselProps> = ({ rewards, title,subTitle, section }) => {
    const { t: translate } = useTranslation();
    const titleProps = title ?? section?.title ??  translate('CONTEST_REWARDS');
    const subTitleProps = subTitle || section?.subTitle;

    return (<>
            {!!rewards?.length &&
                <div className="private-rewards-section-content">
                    {titleProps &&  <JHTML.Title html={titleProps}/>}
                    {subTitleProps &&  <JHTML.SubTitle html={subTitleProps}/>}
                    <JSliderReward rewards={rewards}/>
                </div>
            }
        </>
    )
}

